export default {
      id: "app_store-usage",
      viewBox: "0 0 140 60",
      url: "../dist/images/" + "sprite.svg#app_store-usage",
      toString: function () {
        return this.url;
      }
    }